
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { formatCurrency } from "@/lib/utils";

// Re-export formatCurrency from the global utils
export { formatCurrency };

// Add axisLabelStyle for the charts
export const axisLabelStyle = {
  fill: '#94a3b8',
  fontSize: 10,
  fontWeight: 400
};

export const saveLatestValuesToSupabase = async (
  pricePerUnit: number,
  discountRate: number,
  costPerUnit: number,
  orderVolume: number,
  actualRevenue: number,
  cogs: number,
  grossProfit: number,
  grossProfitMargin: number
) => {
  try {
    // Get the current user
    const { data: { user } } = await supabase.auth.getUser();

    if (!user) {
      console.error("No authenticated user found");
      return;
    }

    // First, check if records already exist
    const { data: existingData, error: queryError } = await supabase
      .from('margin_analysis')
      .select('*');

    if (queryError) {
      console.error('Error checking existing margin analysis data:', queryError);
      return;
    }

    const categories = [
      { name: 'Price Per Unit', value: pricePerUnit },
      { name: 'Discount Rate', value: discountRate },
      { name: 'Cost Per Unit', value: costPerUnit },
      { name: 'Order Volume', value: orderVolume },
      { name: 'Actual Revenue', value: actualRevenue },
      { name: 'COGS', value: cogs },
      { name: 'Gross Profit', value: grossProfit },
      { name: 'Gross Profit Margin', value: grossProfitMargin }
    ];

    // For each category, update if exists or insert if not
    for (const category of categories) {
      const existingRecord = existingData?.find(item => item.category === category.name);

      if (existingRecord) {
        // Update existing record and set the user_id
        const { error: updateError } = await supabase
          .from('margin_analysis')
          .update({ 
            value: category.value,
            user_id: user.id,
            updated_at: new Date().toISOString() // Fix: Convert Date to string
          })
          .eq('id', existingRecord.id);

        if (updateError) {
          console.error(`Error updating ${category.name}:`, updateError);
        }
      } else {
        // Insert new record with user_id
        const { error: insertError } = await supabase
          .from('margin_analysis')
          .insert({ 
            category: category.name, 
            value: category.value,
            user_id: user.id
          });

        if (insertError) {
          console.error(`Error inserting ${category.name}:`, insertError);
        }
      }
    }

    console.log('Successfully saved margin analysis data to Supabase');
  } catch (error) {
    console.error('Error in saveLatestValuesToSupabase:', error);
    toast.error("Failed to save margin analysis data");
  }
};
